import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/filter.svg',
})
export class FilterComponent {}
